import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators, AbstractControl } from '@angular/forms';
import { PopoverController } from '@ionic/angular';
import { InputValidationsService } from '../../services/validations/input-validations.service';
import { jwtDecode } from 'jwt-decode';
import { GlobalService } from '../../services/global/global.service';

@Component({
  selector: 'app-lead-email-input',
  templateUrl: './lead-email-input.component.html',
  styleUrls: ['./lead-email-input.component.scss'],
})
export class LeadEmailInputComponent implements OnInit {
  emailForm!: FormGroup;
  leadDetails: any;
  allFromEmails: any;
  leademail: any;


  @Input() onActionPerformed!: (data: any) => void;

  constructor(
    private _fb: FormBuilder,
    private _popoverController: PopoverController,
    private _validationService: InputValidationsService,
    private _globalService: GlobalService,
  ) { }

  ngOnInit() {

    // this.allFromEmails = this._globalService.retrieveEmailsFromToken();
    this.allFromEmails = this._globalService.retrieveOrganizationVerifiedEmails();

    const currentUser = localStorage.getItem('sub') || '';
    if (
      this._globalService.getUserSenderAccess() === "SUCCESS" &&
      !this.allFromEmails.includes(currentUser)
    ) {
      this.allFromEmails.push(currentUser);
    }

    this.emailForm = this._fb.group({
      emails: this._fb.array([]),
      tempmail: ['', [this._validationService.emailValidator()]],
      fromEmail: [this.allFromEmails.at(-1) || '', [Validators.required, Validators.email]],
    });

    this.emailForm.get('emails')?.valueChanges.subscribe((emails: any[]) => {
      const tempMailControl = this.emailForm.get('tempmail');
      if (emails.length === 0) {
        tempMailControl?.setValidators([Validators.required, this._validationService.emailValidator()]);
      } else {
        tempMailControl?.clearValidators();
      }
      tempMailControl?.updateValueAndValidity();
    });

    const emailsArray = this.emailForm.get('emails') as FormArray;
    if (this.leademail) {
      emailsArray.push(this._fb.control(this.leademail, [this._validationService.emailValidator()]));
    }
  }


  atLeastOneEmail(control: AbstractControl): { [key: string]: boolean } | null {
    const emailsArray = control as FormArray;
    return emailsArray.length > 0 ? null : { 'required': true };
  }
  get emails(): FormArray {
    return this.emailForm.get('emails') as FormArray;
  }

  addEmail(event: any): void {
    const target = event?.target;
    const email = target?.value?.trim();
    if (!email) return;
    const tempMailControl = this.emailForm.get('tempmail');
    // Check if the email is valid according to Angular validators
    if (tempMailControl?.invalid) {
      this.emailForm.markAllAsTouched();
      return;
    }

    // Check for duplicate emails
    const isDuplicate = this.emails.controls.some(ctrl => ctrl.value === email);
    if (isDuplicate) {
      tempMailControl?.setErrors({ duplicate: true });
      return;
    }

    // Add the email to the emails FormArray if valid and not a duplicate
    this.emails.push(this._fb.control(email, [Validators.required, Validators.email]));

    // Clear the input box and reset the tempmail control
    event.target.value = '';
    tempMailControl?.reset();
  }



  removeEmail(index: number): void {
    this.emails.removeAt(index);
  }

  getEmailErrorMessage(control: any): string {
    if (!control.touched) {
      return ''; // Don't show any error if the control hasn't been touched
    }
    if (control.hasError('required')) {
      return '*Atleast One Email is required';
    }
    if (control.hasError('email')) {
      return '*Invalid email format';
    }
    if (control.hasError('duplicate')) {
      return '*This email is already added';
    }
    return '';
  }

  closeModal() {
    this._popoverController.dismiss();
  }

  onSubmit() {
    this.emailForm.markAllAsTouched();
    if (this.emailForm.get('tempmail')?.value !== '') {
      this.addEmail({ target: { value: this.emailForm.get('tempmail')?.value } });
    }
    if (this.emails.length === 0) {
      this.emailForm.get('tempmail')?.setErrors({ required: true });
      return
    }
    if (this.emailForm.valid) {
      const emailList = this.emails.value
      this.closeModal();
      const data = {
        fromEmail: this.emailForm.value.fromEmail,
        toEmails: emailList
      }
      this.onActionPerformed(data);
    } else {
      this.emailForm.markAllAsTouched();
    }
  }

  onCancel() {
    this.closeModal();
    this.onActionPerformed(null);
  }
}
